<form class="modal-form" [formGroup]="form" (ngSubmit)="submit()">
  @if (!created) {
    <app-modal-header
      title="Create new API key"
      subtitle="Generate a new key for authenticating API requests. You can reveal it again anytime from your key list."
    />
  } @else {
    <app-modal-header title="Your new key" [subtitle]="createdKeyName" />
  }

  <app-modal-body>
    <div class="create-key">
      @if (!created) {
        <label class="create-section__label" for="key-name">Key name</label>
        <input
          id="key-name"
          formControlName="name"
          type="text"
          class="field-input"
          placeholder="e.g. Production API, Backend service…"
          autocomplete="off"
          data-modal-autofocus
        />
      } @else {
        <div class="key-secret">
          <span class="key-secret__value">{{ revealed ? apiKey : '••••••••••••••••••••••••' }}</span>
          <button
            class="key-secret__toggle"
            type="button"
            [attr.aria-label]="revealed ? 'Hide key' : 'Show key'"
            (click)="toggleRevealed()"
          >
            @if (!revealed) {
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" width="16" height="16" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                <path stroke-linecap="round" stroke-linejoin="round" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
              </svg>
            } @else {
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" width="16" height="16" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88" />
              </svg>
            }
          </button>
          <button class="key-box__copy" type="button" [class.key-box__copy--copied]="copied" (click)="copyKey()">
            @if (!copied) {
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M5 6.5C5 5.67157 5.67157 5 6.5 5H12.5C13.3284 5 14 5.67157 14 6.5V12.5C14 13.3284 13.3284 14 12.5 14H6.5C5.67157 14 5 13.3284 5 12.5V6.5Z" fill="currentColor"/>
                <path d="M3.5 2C2.67157 2 2 2.67157 2 3.5V9.5C2 10.3284 2.67157 11 3.5 11L3.5 6.5C3.5 4.84315 4.84315 3.5 6.5 3.5H11C11 2.67157 10.3284 2 9.5 2H3.5Z" fill="currentColor"/>
              </svg>
            } @else {
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M13.7803 4.21967C14.0732 4.51256 14.0732 4.98744 13.7803 5.28033L6.53033 12.5303C6.23744 12.8232 5.76256 12.8232 5.46967 12.5303L2.21967 9.28033C1.92678 8.98744 1.92678 8.51256 2.21967 8.21967C2.51256 7.92678 2.98744 7.92678 3.28033 8.21967L6 10.9393L12.7197 4.21967C13.0126 3.92678 13.4874 3.92678 13.7803 4.21967Z" fill="currentColor"/>
              </svg>
            }
            {{ copied ? 'Copied!' : 'Copy key' }}
          </button>
        </div>
      }
    </div>
  </app-modal-body>

  <app-modal-footer>
    @if (!created) {
      <button type="button" class="btn--secondary" [disabled]="isLoading" (click)="modalRef.dismiss()">Cancel</button>
      <button type="submit" class="btn--primary" [disabled]="isLoading || form.invalid">
        {{ isLoading ? 'Generating…' : 'Generate key' }}
      </button>
    } @else {
      <button type="button" class="btn--primary" (click)="modalRef.close(true)">Done</button>
    }
  </app-modal-footer>
</form>
